import { Buffer } from "buffer";
import process from "process";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import configureStore from "./services/store";
import "./styles/index.css";
import App from "./components/app/App";
import i18n, { initI18n } from "./i18n";

window.Buffer = Buffer;
window.process = process;

const startApp = async () => {
  await initI18n();

  const RootApp = () => {
    const language = i18n.language;
    const direction = language === "he" || language === "ar" ? "rtl" : "ltr";
    return (
      <GoogleOAuthProvider clientId="836909669526-6485q0i3v8rb2ijhcktlrk5beoh6ffne.apps.googleusercontent.com">
        <React.StrictMode>
          <Provider store={configureStore}>
            <BrowserRouter>
              {/* <div dir={direction}> */}
              <App />
              {/* </div> */}        </BrowserRouter>
          </Provider>
        </React.StrictMode>
      </GoogleOAuthProvider>
    );
  };

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(<RootApp />);
};
startApp();

